/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MstUserOutput } from './MstUserOutput';
import {
    MstUserOutputFromJSON,
    MstUserOutputFromJSONTyped,
    MstUserOutputToJSON,
    MstUserOutputToJSONTyped,
} from './MstUserOutput';
import type { ResponseUpdateError } from './ResponseUpdateError';
import {
    ResponseUpdateErrorFromJSON,
    ResponseUpdateErrorFromJSONTyped,
    ResponseUpdateErrorToJSON,
    ResponseUpdateErrorToJSONTyped,
} from './ResponseUpdateError';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseUserCreate
 */
export interface ResponseUserCreate {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseUserCreate
     */
    result: ResponseResult;
    /**
     * 
     * @type {Array<ResponseUpdateError>}
     * @memberof ResponseUserCreate
     */
    errors: Array<ResponseUpdateError> | null;
    /**
     * 
     * @type {number}
     * @memberof ResponseUserCreate
     */
    updateCount: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ResponseUserCreate
     */
    lastUpdateDatetime: Date | null;
    /**
     * 
     * @type {MstUserOutput}
     * @memberof ResponseUserCreate
     */
    data: MstUserOutput | null;
}

/**
 * Check if a given object implements the ResponseUserCreate interface.
 */
export function instanceOfResponseUserCreate(value: object): value is ResponseUserCreate {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    if (!('updateCount' in value) || value['updateCount'] === undefined) return false;
    if (!('lastUpdateDatetime' in value) || value['lastUpdateDatetime'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseUserCreateFromJSON(json: any): ResponseUserCreate {
    return ResponseUserCreateFromJSONTyped(json, false);
}

export function ResponseUserCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseUserCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'errors': (json['errors'] == null ? null : (json['errors'] as Array<any>).map(ResponseUpdateErrorFromJSON)),
        'updateCount': json['update_count'],
        'lastUpdateDatetime': (json['last_update_datetime'] == null ? null : new Date(json['last_update_datetime'])),
        'data': MstUserOutputFromJSON(json['data']),
    };
}

export function ResponseUserCreateToJSON(json: any): ResponseUserCreate {
    return ResponseUserCreateToJSONTyped(json, false);
}

export function ResponseUserCreateToJSONTyped(value?: ResponseUserCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'errors': (value['errors'] == null ? null : (value['errors'] as Array<any>).map(ResponseUpdateErrorToJSON)),
        'update_count': value['updateCount'],
        'last_update_datetime': value['lastUpdateDatetime'] == null ? value['lastUpdateDatetime'] : value['lastUpdateDatetime'].toISOString(),
        'data': MstUserOutputToJSON(value['data']),
    };
}

